import "polyfills/nodelist-foreach";
import Vue from "vue";
import Banner from "@/features/banner/components/banner";
import SaleBanner from "@/features/banner/components/sale-banner";
import globals from "@/utils/globals";
import store from "@/store/";

export const initBanners = () => {
  const el = getElement();

  if (!el) {
    return;
  }

  const banners = globals.banner || {};
  Object.keys(banners).forEach(id => {
    const {
      type, content, event: eventCategory, cookie
    } = banners[id];
    createBanner(el, {
      id,
      type,
      content,
      cookie,
      eventCategory
    });
  });
};

export const initSalesBanner = () => {
  if (globals.salesBannerDisabled) {
    return;
  }

  const el = getElement();

  if (!el) {
    return;
  }

  store.dispatch("sales/load", document);

  new Vue({
    name: "SaleBannerInit",
    el,
    store,
    render: h => h(SaleBanner)
  });
};

const getElement = () => {
  const el = document.createElement("div");
  const container = document.getElementById("banners-vue");

  if (!container) {
    return;
  }

  container.appendChild(el);

  return el;
};

const createBanner = (el, props) => {
  const timeout = props.timeout || 0;
  const vm = new Vue({
    name: "BannerInit",
    el,
    components: { Banner },
    data() {
      return {
        modifiers: [],
        ...props,
        show: false
      };
    },
    template: `
      <banner
        :id="id"
        :type="type"
        :content="content"
        :cookie="cookie"
        :event-category="eventCategory"
        :modifiers="modifiers"
        :show="show" />
    `
  });
  setTimeout(() => vm.show = true, timeout);
};
